import { render, staticRenderFns } from "./SolutionPage.vue?vue&type=template&id=b74b2bae&"
import script from "./SolutionPage.vue?vue&type=script&lang=js&"
export * from "./SolutionPage.vue?vue&type=script&lang=js&"
import style0 from "./SolutionPage.vue?vue&type=style&index=0&id=b74b2bae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports